export default __webpack_public_path__ + "static/media/114424.cfa892e6.jpg";